module.exports = __webpack_public_path__ + "media/images/leistungen-trenner-086444f033937deeb878c4ad174f78c3.png";